import React from 'react';
import { Outlet } from 'react-router';
import PreviewModeToggleNavigation from '../../components/PreviewModeToggleNavigation';
import PreviewPatchListingProvider from '../../providers/PreviewPatchListing';

const UnderExternalAdministration: React.FC = () => {
  return (
    <PreviewPatchListingProvider>
      <PreviewModeToggleNavigation />
      <Outlet />
    </PreviewPatchListingProvider>
  );
};

export default UnderExternalAdministration;
